import { ShieldCheck, Zap, FileText } from "lucide-react";
import { SITE, priceCta } from "@/config/site";
import { CtaButton } from "./CtaButton";
import { Reveal } from "./Reveal";

const ASSURANCES = [
  { icon: FileText, label: "Kompletní PDF e-book" },
  { icon: Zap, label: "Ihned po zaplacení" },
  { icon: ShieldCheck, label: "Bezpečná platba přes SimpleShop" },
];

export const Pricing = () => (
  <section
    id="cenova-nabidka"
    className="grain relative overflow-hidden bg-navy py-28 sm:py-36"
    data-testid="pricing-section"
  >
    <div
      aria-hidden="true"
      className="pointer-events-none absolute left-1/2 top-1/2 h-[70vh] w-[90vw] -translate-x-1/2 -translate-y-1/2 rounded-[100%] bg-[radial-gradient(ellipse_at_center,rgba(201,127,82,0.12),transparent_60%)]"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 top-0 h-48 bg-[radial-gradient(70%_100%_at_50%_0%,rgba(201,127,82,0.14),transparent_70%)]"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 bottom-0 h-48 bg-[radial-gradient(70%_100%_at_50%_100%,rgba(166,90,58,0.12),transparent_70%)]"
    />
    <div className="relative z-10 mx-auto max-w-3xl px-5 sm:px-8">
      <Reveal>
        <p className="text-center text-xs font-semibold uppercase tracking-[0.3em] text-copper">
          Zaváděcí cena pro prvních {SITE.introLimit} čtenářů
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="mt-10 rounded-lg border border-white/10 bg-navy-deep/80 p-10 text-center backdrop-blur-sm sm:p-14">
          <p className="font-serif text-2xl italic text-cream/70">{SITE.bookTitle}</p>

          <p
            className="mt-8 font-serif text-7xl font-medium leading-none tracking-tight text-cream sm:text-8xl"
            data-testid="intro-price"
          >
            {SITE.introPrice}&nbsp;Kč
          </p>
          <p className="mt-4 text-sm text-cream/50">
            Po prvních {SITE.introLimit} čtenářích {SITE.futurePrice}&nbsp;Kč
          </p>

          <div className="mx-auto mt-10 h-px w-24 bg-copper/40" aria-hidden="true" />

          <ul className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center sm:gap-8">
            {ASSURANCES.map((a) => (
              <li key={a.label} className="flex items-center gap-2 text-sm text-cream/70">
                <a.icon className="h-4 w-4 text-copper" strokeWidth={1.5} aria-hidden="true" />
                {a.label}
              </li>
            ))}
          </ul>

          <div className="mt-10">
            <CtaButton event="pricing_cta" location="pricing" size="lg" testId="pricing-cta" className="w-full sm:w-auto">
              {priceCta}
            </CtaButton>
          </div>
          <p className="mt-5 text-xs tracking-wide text-cream/45">
            Jednorázová platba · žádné předplatné · PDF ihned po zaplacení
          </p>
        </div>
      </Reveal>

      <Reveal delay={0.2}>
        <p className="mt-8 text-center text-xs leading-relaxed text-cream/40">
          Objednávku, platbu, fakturaci a doručení e-booku zajišťuje česká služba SimpleShop.
          Po kliknutí budeš přesměrován do zabezpečeného objednávkového formuláře.
        </p>
      </Reveal>
    </div>
  </section>
);
